import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'reactstrap'

class DateInput extends React.Component {

    static propTypes = {
        date: PropTypes.oneOfType([ PropTypes.number,PropTypes.string ]),
        onDateChange: PropTypes.func
    }

    handleInputChange = e => {
        this.props.onDateChange(e.target.value)
    }

    render() {
        const date = this.props.date
        return (
            <Input
                type="date"
                value={ date }
                onChange={ this.handleInputChange }
                required pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" />
        )
    }
}
export default DateInput
